<template>
    <input type="text" class="form-control inputElement" :value="value" :id="'value-'+id" autocomplete="off">  
</template>

<script>
export default {
  name: "TextInput",
  props: ["value", "id"],
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/input/TextInput.vue